import {gql} from 'apollo-angular';

export const GET_ROOKIE_DISTRICT_STATE = gql`
  query GetRookieDistrictState($districtId: Int!) {
    rookieDistrictState(districtId: $districtId)
  }
`;
